import React, { useState } from "react";
import {TextField, Button, Stack, ListItemText, List, Container, Divider} from '@mui/material';

import { useGetLogsQuery  } from "services/ustires";

const DotResearch = () => {
    
    const [dot, setDot] = useState("");

    const { appDetails, appLogs, appRecallsCount, appComplaintsCount, appInvestigationsCount, appCommunicationsCount } = useGetLogsQuery(
      { 
          dot:dot.trim()
      }, 
      {
          skip: !dot.length>0,
          selectFromResult: ({ data, status, isLoading, isFetching }) => ({
              appDetails: data?.content || [],
              appLogs: data?.log?.logs || [],
              appRecallsCount: data?.recallsCount || 0,
              appComplaintsCount: data?.complaintsCount || 0,
              appInvestigationsCount: data?.investigationsCount || 0,
              appCommunicationsCount: data?.communicationsCount || 0
          })
      }
  );

  console.log(appDetails, appLogs, appRecallsCount, appComplaintsCount);

    return (
        <Container>
          <Stack spacing={2} sx={{paddingTop: "20px", margin: "20px"}} display={'flex'} direction={'row'} alignItems={'center'} justifyContent={'center'}>
            
            <TextField
              fullWidth
              required
              label=""
              name="dot"
              value={dot}
              onChange={(event)=>setDot(event.target.value)}
              autoFocus
              variant="outlined"
              helperText="Enter DOT to research"
              margin="normal"
              sx={{
                border: '1px solid #E2E2E6', 
                borderRadius: 1,
                width: "60%"
              }}
              InputProps={{ 
                style: {
                  borderRadius: 2, 
                  //color: "#E2E2E6",
                  fontSize: "16px"
                }
              }}
            />
            {/* <Button variant="contained" size={'large'}>Research</Button> */}
          </Stack>
          <Stack spacing={2} sx={{padding: "25px"}} display={'flex'} direction={'column'} alignItems={'stretch'} justifyContent={'flex-start'}>
            {appLogs.map((l, i)=>
              <Container k={i}>
                <ListItemText prefix={i} primary={l.title} secondary={l.description}/>
                <Divider />
              </Container>
              )}
          </Stack>
        </Container>
    );
}

export default DotResearch;